import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';

export type AiSearchTemplateProps = {
  /** A PageHeader stating the grounding rule (answers come only from the index). */
  header: ReactNode;
  /** A large SearchField for the question. */
  search: ReactNode;
  /** The AnswerCard, with its cited JobCards in `results`. */
  answer?: ReactNode;
  className?: string;
};

/** AI search (/ai-search). */
export function AiSearchTemplate({ header, search, answer, className }: AiSearchTemplateProps) {
  return (
    <PageContainer width="prose" className={className}>
      <div className="flex flex-col gap-jc-block py-jc-section">
        {header}
        {search}
        {answer}
      </div>
    </PageContainer>
  );
}
